// extracted by mini-css-extract-plugin
module.exports = {"countriesList":"CountriesList_countriesList__1mZV5","list":"CountriesList_list__2Wa7B","title":"CountriesList_title__3npJf"};